import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useClipboard } from '@root/shared'
import { Textarea } from '@root/shared/ui-kit'

import {
  exportedWalletsContentAtom,
  processExportWalletsAction,
} from '../../atoms/reatom-port-wallets'

export const PortWalletsDrawerExport: React.FC = () => {
  const { t } = useTranslation()
  const { copyToClipboard } = useClipboard()
  const [content] = useAtom(exportedWalletsContentAtom)
  const exportWalletsAction = useAction(processExportWalletsAction)

  const handleCopy = () => {
    if (!content) {
      return
    }
    copyToClipboard(content, {
      showSnackbar: true,
      snackbarText: t('common.copied'),
    })
  }
  const handleExport = async () => {
    exportWalletsAction()
  }

  return (
    <Root>
      <Text
        onKeyDown={(e) => {
          // prevent backspace from navigating to the previous URL
          e.stopPropagation()
          e.preventDefault()
        }}
        value={content}
        label={t('wallet-tracker.port.export-description')}
        rows={15}
        readOnly
      />

      <Footer>
        <FooterButton
          variant="soft"
          size="xs"
          radius="rounded"
          type="button"
          disabled={!content}
          onClick={handleCopy}
        >
          {t('common.copy')}
        </FooterButton>
        <FooterButton
          variant="soft"
          size="xs"
          radius="rounded"
          type="button"
          onClick={handleExport}
          disabled={!content}
        >
          {t('wallet-tracker.port.tab.export')}
        </FooterButton>
      </Footer>
    </Root>
  )
}

const Root = styled.div`
  border-radius: 12px;
  padding: 18px 14px 0;
  overflow: auto;
  height: 100%;
  background: inherit;
`

const Text = styled(Textarea)``

const Footer = styled.footer`
  position: sticky;
  bottom: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 16px 0 8px;
  background: inherit;
`

const FooterButton = styled(Button)`
  height: 34px;
  min-width: 100px;
  border-radius: 6px;
  padding-inline: 12px;
`
